module.exports = __webpack_public_path__ + "img/reimu hakurei scarlet_sc2.0dd8911d.png";